import styled from 'styled-components'
import { InputMaskForm, SecondaryButton } from '../../global.styles'

export const SendButton = styled(SecondaryButton)`
  background: ${props => (props.showButton ? 'green' : 'white')} !important;
`
export const PinCodeInput = styled(InputMaskForm)`
  border: 1px solid ${props => (props.showError ? 'red' : 'transparent')} !important;
`
